export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-cloud-356193863d510756d362ee558564cc06.svg";